import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the masters of the platform with the filters and the numbers */
export const list = data => {
    const uri = `${env.startpoint}/admin/master/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — the whole card of one master */
export const get = data => {
    const uri = `${env.startpoint}/admin/master/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
